import React from "react";

import { AxiomTooltipNew } from "../AxiomTooltip/AxiomTooltip.jsx";

import Unsorted from "./unsort.svg";
import SortDown from "./sortdown.svg";
import SortUp from "./sortup.svg";
import IoAndroidSearch from "react-icons/lib/io/android-search";

export default class AxiomBarChartHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipShow: false
    };
  }

  render() {
    return (
      <div className="AxiomBarChartView_Table HeaderTable">
        <div className="AxiomBarChartView_TableHeader">
          {this.props.columnData.map((colData, index) => {
            return (
              <div
                className="AxiomBarChartView_TableHeaderColumn"
                key={index}
                style={colData.style && colData.style}>
                {colData.displayNameComponent ? (
                  colData.displayNameComponent
                ) : (
                  <div className={"thLabel"}>
                    <AxiomTooltipNew
                      place="bottom"
                      tooltip={
                        this.state.tooltipShow &&
                        (colData.tooltipDisplayName || "")
                      }>
                      <span className="AxiomBarChartView_TableHeaderLabel">
                        {colData.displayName || ""}
                      </span>
                    </AxiomTooltipNew>
                  </div>
                )}
                {!this.props.hideSortIcons && (
                  <div
                    className={
                      "AxiomBarChartView_TableHeaderColumn_Icons"
                    }>
                    {colData.showSearch && (
                      <div className="AxiomBarChart_Searchbar_container">
                        <div
                          onClick={() => {
                            this.props.openSearchbar(colData, index);
                          }}
                          className="AxiomBarChart_SingleKPI_ToolBar_Icon">
                          <IoAndroidSearch size={30} />
                        </div>
                      </div>
                    )}
                    {
                      <div
                        onClick={() => this.props.toggleSort(colData, index)}
                        className="AxiomBarChart_SingleKPI_ToolBar_Icon">
                        {colData.sorting == "" ? (
                          <img
                            className={
                              colData.displayName == ""
                                ? "countThSortImg"
                                : "sortImg"
                            }
                            src={
                              this.props.unSortIcon
                                ? this.props.unSortIcon
                                : Unsorted
                            }
                          />
                        ) : colData.sorting == "desc" ? (
                          <img
                            className={
                              colData.displayName == ""
                                ? "countThSortImg"
                                : "sortImg"
                            }
                            src={
                              this.props.sortDownIcon
                                ? this.props.sortDownIcon
                                : SortDown
                            }
                          />
                        ) : (
                          <img
                            className={
                              colData.displayName == ""
                                ? "countThSortImg"
                                : "sortImg"
                            }
                            src={
                              this.props.sortUpIcon
                                ? this.props.sortUpIcon
                                : SortUp
                            }
                          />
                        )}
                      </div>
                    }
                  </div>
                )}
                {colData.showSearch && (
                  <div
                    className={
                      "AxiomBarChart_SearchbarTransition" +
                      (colData.searchState
                        ? " AxiomBarChart_SearchbarOpen"
                        : " AxiomBarChart_Searchbar")
                    }>
                    <input
                      ref={instance => {
                        this.props.setSearchBarRef(
                          instance,
                          colData.displayName
                        );
                      }}
                      onChange={this.props.handleSearchQuery}
                      placeholder="Search"
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
